import MetricsPage from "@/interface/pages/metrics-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/metrics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <MetricsPage />;
}
